module.exports = "/app/themes/roboyo2021/dist/img/location-bk.png?44b500b3be4889cfd69f8b2db0c13767";